module.exports = {
	"id": "AR",
	"name": "Argentina",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011264,
			"12": 0.005632,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.016896,
			"19": null,
			"20": null,
			"21": 0.011264,
			"22": 0.02816,
			"23": null,
			"24": null,
			"25": 0.005632,
			"26": 0.039424,
			"27": 0.02816,
			"28": 0.005632,
			"29": 0.005632,
			"30": 0.011264,
			"31": 0.033792,
			"32": 0.011264,
			"33": 0.016896,
			"34": 0.067584,
			"35": 0.061952,
			"36": 0.033792,
			"37": 0.039424,
			"38": 0.061952,
			"39": 0.05632,
			"40": 0.033792,
			"41": 0.033792,
			"42": 0.039424,
			"43": 0.129536,
			"44": 0.08448,
			"45": 0.067584,
			"46": 0.129536,
			"47": 0.123904,
			"48": 0.095744,
			"49": 4.483072,
			"50": 0.1408,
			"51": 0.523776,
			"52": 0.444928,
			"53": 27.377152,
			"54": 7.77216,
			"55": 0.067584,
			"56": 0.011264,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.011264,
			"4": null,
			"5": null,
			"6": 0.005632,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011264,
			"12": 0.02816,
			"13": null,
			"14": null,
			"15": 0.016896,
			"16": 0.005632,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.005632,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.005632,
			"25": null,
			"26": 0.005632,
			"27": 0.011264,
			"28": null,
			"29": 0.022528,
			"30": 0.011264,
			"31": 0.016896,
			"32": 0.005632,
			"33": 0.011264,
			"34": 0.016896,
			"35": 0.011264,
			"36": 0.011264,
			"37": 0.022528,
			"38": 0.045056,
			"39": 0.02816,
			"40": 0.022528,
			"41": 0.022528,
			"42": 0.022528,
			"43": 0.11264,
			"44": 0.02816,
			"45": 0.101376,
			"46": 0.050688,
			"47": 0.292864,
			"48": 0.275968,
			"49": 4.28032,
			"50": 0.033792,
			"51": null,
			"52": null,
			"3.5": 0.011264,
			"3.6": 0.016896
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.011264,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.033792,
			"37": 0.039424,
			"38": 0.016896,
			"39": 0.005632,
			"40": 0.287232,
			"41": 0.050688,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.022528
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.011264,
			"6": null,
			"7": 0.005632,
			"8": 0.033792,
			"9": 0.045056,
			"10": 0.30976,
			"3.1": null,
			"3.2": null,
			"5.1": 0.016896,
			"6.1": 0.011264,
			"7.1": null,
			"9.1": 0.191488
		},
		"ios_saf": {
			"8": 0,
			"10": 1.64824534221,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.044418304746,
			"8.1-8.4": 0.0820609358868,
			"9.0-9.2": 0.0391483363863,
			"9.3": 0.597263080766
		},
		"android": {
			"3": 0,
			"4": 0.0554634418605,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00693293023256,
			"4.1": 0.20006455814,
			"4.2-4.3": 0.500161395349,
			"4.4": 1.14690474419,
			"4.4.3-4.4.4": 1.15680893023
		},
		"ie": {
			"6": 0.0565225899281,
			"7": 0.0452180719424,
			"8": 0.474789755396,
			"9": 0.310874244604,
			"10": 0.237394877698,
			"11": 2.01785646043,
			"5.5": null
		},
		"op_mob": {
			"0": 0.111454668721,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00309596302003
		},
		"edge": {
			"12": 0.067584,
			"13": 0.22528,
			"14": 0.540672
		},
		"ie_mob": {
			"10": 0.408254197183,
			"11": 1.66217780282
		},
		"bb": {
			"7": 0.020748,
			"10": null
		},
		"samsung": {
			"0": 1.61616
		},
		"and_uc": {
			"0": 0.214032
		},
		"op_mini": {
			"0": 1.50160936826
		},
		"and_chr": {
			"0": 35.296208
		},
		"and_ff": {
			"0": 0.013104
		}
	},
	"total": 99.084892
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AR.json
 ** module id = 464
 ** module chunks = 0
 **/